import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration as  ApiConfiguration01 } from '../../api/questionnaireApi/api-configuration';
@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private http: HttpClient,
    private config1: ApiConfiguration01,
  ) { }
  setUrlConfig() {
    return this.http.get('./assets/config/url.json').toPromise().then((result) => {
      const urlArry=window.location.href.split("/");
      const routerUrl=urlArry[urlArry.length-1];
      if(routerUrl=="reportpage"){ 
        console.log("当前地址 routerUrl：",routerUrl);
        this.config1.rootUrl = result['questionnaireApi_reportpage'];
      }else{
        this.config1.rootUrl = result['questionnaireApi'];
      }
     
      return result;
    }).catch((err) => {
      console.log(err);
    });
  }
}
